import React, { useState, useEffect } from 'react'
import { BlockPicker, ChromePicker } from 'react-color'
import './CCColorPicker.scss'

const DEFAULT_TAG_COLORS = [
  {
    name: 'Tag-1',
    color: '#BB77FF'
  },
  {
    name: 'Tag-2',
    color: '#7533FF'
  },
  {
    name: 'Tag-3',
    color: '#0099CC'
  },
  {
    name: 'Tag-4',
    color: '#3377FF'
  },
  {
    name: 'Tag-5',
    color: '#FFBB33'
  },
  {
    name: 'Tag-6',
    color: '#FF7733'
  },
  {
    name: 'Tag-7',
    color: '#FF0077'
  },
  {
    name: 'Tag-8',
    color: '#BB0077'
  },
  {
    name: 'Tag-9',
    color: '#FF3333'
  },
  {
    name: 'Tag-10',
    color: '#CC0033'
  },
  {
    name: 'Tag-11',
    color: '#00CC77'
  },
  {
    name: 'Tag-12',
    color: '#007777'
  },
]

const CCColorPicker = (props) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false)
  const [color, setColor] = useState(props.value || '#fff')

  useEffect(() => {
    setColor(props.value)
  }, [props.value])

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker)
  };

  const handleClose = () => {
    setDisplayColorPicker(false)
  };

  const onChangeComplete = (newColor) => {
    setColor(newColor.hex)

    if (props.onChange) {
      props.onChange(newColor.hex)
    }
  }

  const defaultColors = DEFAULT_TAG_COLORS.map(dtc => dtc.color)

  return (
    <div className="cc-color-picker-container">
      <div onClick={handleClick} className="color-picker">
        <div style={{ backgroundColor: color }} className="color-pane" />
        <div className="color-value">{color}</div>
      </div>
      {displayColorPicker ? <div className="popover">
        <div className="cover" onClick={handleClose} />
        <ChromePicker onChange={onChangeComplete} color={color} />
        <BlockPicker
          onChange={onChangeComplete}
          color={color}
          colors={defaultColors}
          width="100%"
        />
      </div> : null }
    </div>
  )
}

export default CCColorPicker
